module.exports = __webpack_public_path__ + "static/media/Euphemia-UCAS-Bold.274e9e70.ttf";